type ApprovedIconProps = {
	style: React.CSSProperties;
};

ApprovedIcon.defaultProps = {
	style: {},
};

export default function ApprovedIcon({ style }: ApprovedIconProps) {
	return (
		<div
			className="icon-approved"
			style={{
				fontSize: '12px',
				position: 'absolute',
				bottom: 6,
				right: -1,
				color: 'green',
				...style,
			}}
		/>
	);
}
